export const SEGMENT_COLORS = {
  brandFans: '#2E5AAC',
  nano: '#4F7DBA',
  micro: '#55A2DF',
  midTier: '#7FC4F3',
  macro: '#A6D5F2',
  mega: '#C6E9F9',
} as const;

export type SegmentType = keyof typeof SEGMENT_COLORS;

// Order based on follower count ranges
export const SEGMENT_ORDER: { [key: string]: number } = {
  brandFans: 0, // < 2,500
  nano: 1, // < 25,000
  micro: 2, // < 60,000
  midTier: 3, // < 250,000
  macro: 4, // < 1,000,000
  mega: 5, // >= 1,000,000
};

export const SEGMENT_RANGES: { [key: string]: string } = {
  brandFans: 'with less than 2,500 followers',
  nano: 'between 2,500 and 24,999 followers',
  micro: 'between 25,000 and 59,999 followers',
  midTier: 'between 60,000 to 249,999 followers',
  macro: 'between 250,000 to 999,999 followers',
  mega: 'with over 1M followers',
};

export const UI_LABELS: { [key: string]: string } = {
  brandFans: 'Brand Fans',
  nano: 'Nano',
  micro: 'Micro',
  midTier: 'Mid-tier',
  macro: 'Macro',
  mega: 'Mega',
};
